import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import ClassifyBreadcrumbs from '@classify/react-core-components/Breadcrumbs';
import { translate } from '@openclassrooms/translations';
import BreadcrumbsItem from './BreadcrumbsItem';
interface Props {
  children: ReactNode;
  isOnContrasted?: boolean;
}
export default function Breadcrumbs(t0) {
  const $ = _c(5);
  const {
    children,
    isOnContrasted: t1
  } = t0;
  const isOnContrasted = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("navigation.breadcrumbs.aria_label");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BreadcrumbsItem to="/">{translate("global.word.home")}</BreadcrumbsItem>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== isOnContrasted) {
    t4 = <ClassifyBreadcrumbs isOnContrasted={isOnContrasted} aria-label={t2}>{t3}{children}</ClassifyBreadcrumbs>;
    $[2] = children;
    $[3] = isOnContrasted;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}